export default __webpack_public_path__ + "static/media/MorganThomas.310d06dc.png";